import {
  Directive,
  Input,
  ElementRef,
  Renderer2,
  SimpleChanges,
  inject,
} from '@angular/core';

@Directive({
  selector: '[animateOnChange]',
  standalone: true,
})
export class AnimateOnChangeDirective {
  private el: ElementRef = inject(ElementRef);
  private renderer: Renderer2 = inject(Renderer2);
  private previousValue: string;

  @Input('animateOnChange') value: string;

  ngOnChanges(changes: SimpleChanges) {
    if (changes['value'] && !changes['value'].firstChange) {
      this.el.nativeElement.textContent = this.previousValue;
      this.renderer.addClass(this.el.nativeElement, 'price-fade-out');
      setTimeout(() => {
        this.renderer.removeClass(this.el.nativeElement, 'price-fade-out');
        this.el.nativeElement.textContent = this.value;
        this.renderer.addClass(this.el.nativeElement, 'price-fade-in');
        setTimeout(() => {
          this.renderer.removeClass(this.el.nativeElement, 'price-fade-in');
        }, 200);
      }, 200);
    } else {
      this.el.nativeElement.textContent = this.value;
    }
    this.previousValue = this.value;
  }
}
